import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/shipping-tracking/components/DEShippingTrackingClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/shipping-tracking/components/FRShippingTrackingClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/shipping-tracking/components/ShippingTrackingClient.tsx");
